export default __webpack_public_path__ + "static/media/dipu.6b480d22.png";